<template>
  <div v-if="is_tools" class="tools">
    <line-elevation
      v-show="line_elevation"
      :line_elevation="line_elevation"
      @close="line_elevation = null"
    ></line-elevation>
    <div class="is-box is-box--tool" v-show="is_tools">
      <header class="card-header">
        <p class="card-header-title is-semibold-16-600-19" >
          {{ localization("app-calculation", "Calculation") }}
        </p>
        <a
          @click="is_tools = false"
          class="card-header-icon"
          aria-label="more options"
        >
          <span class="icon">
            <svg viewBox="0 0 100 100" class="image is-16x16 mr-10">
              <use xlink:href="@/assets/icons/helper_sprite.svg#close" />
            </svg>
          </span>
        </a>
      </header>
      <div class="card-content" style="padding: 0 0">
        <div class="tabs is-fullwidth" style="margin-bottom: 0.5rem">
          <ul>
            <li :class="{ 'is-active': is_volume_card }">
              <a class="is-semibold-16-600-19" >{{
                localization("app-volume", "Volume")
              }}</a>
            </li>
            <li :class="{ 'is-active': is_elevation_card }">
              <a class="is-semibold-16-600-19" >{{
                localization("app-elevation", "Elevation")
              }}</a>
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <smooth-scrollbar>
            <div style="height: 80vh; padding: 0.5rem">
              <div class aria-id="volumeCalculation" v-if="is_volume_card">
                <div
                  slot="trigger"
                  slot-scope="props"
                  class="card-header"
                  role="button"
                  @click="is_volume_card = !is_volume_card"
                  aria-controls="contentIdForA11y3"
                >
                  <p
                    class="card-header-title is-uppercase is-size-7"
                    
                  >
                    {{
                      localization(
                        "app-volume-calculation",
                        "Volume Calculation"
                      )
                    }}
                  </p>
                  <a class="card-header-icon">
                    <b-icon
                      :icon="props.open ? 'menu-down' : 'menu-up'"
                    ></b-icon>
                  </a>
                </div>
                <div class="card-content" style="padding: 0 10px">
                  <div class="form">
                    <div class="field">
                      <div class="is-size-7 prop-title" >
                        {{ localization("app-method", "Method") }}
                      </div>
                      <div class="select" >
                        <select v-model="form.method">
                          <option value="base-height">
                            {{ localization("app-base-height", "Base-Height") }}
                          </option>
                          <option value="flat-minimum">
                            {{
                              localization("app-flat-minimum", "Flat minimum")
                            }}
                          </option>
                          <option value="triangulated">
                            {{
                              localization("app-triangulated", "Triangulated")
                            }}
                          </option>
                          <option value="surface-to-surface">
                            {{
                              localization(
                                "app-surface-to-surface",
                                "Surface to Surface"
                              )
                            }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div v-if="form.method == 'surface-to-surface'">
                      <div class="field">
                        <div class="is-size-7 prop-title" >
                          {{ localization("app-layer-1", "Layer 1") }}
                        </div>
                        <DsmDtmDropdown @input="layer1 = $event" />
                      </div>
                      <div class="field">
                        <div class="is-size-7 prop-title" >
                          {{ localization("app-layer-2", "Layer 2") }}
                        </div>
                        <DsmDtmDropdown @input="layer2 = $event" />
                      </div>
                    </div>

                    <div
                      class="field"
                      v-if="
                        form.method == 'base-height' ||
                        form.method == 'triangulated' ||
                        form.method !== 'surface-to-surface'
                      "
                    >
                      <div class="is-size-7 prop-title" >
                        {{ localization("app-layer", "Layer") }}
                      </div>
                      <div class="select">
                        <select v-model="form.layer" class="is-uppercase">
                          <option
                            v-for="(report, i) of reports"
                            :key="i"
                            :value="report.key"
                          >
                            {{ report.key }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div v-if="form.method == 'base-height'" class="field">
                      <div class="is-size-7 prop-title" >
                        {{ localization("app-height", "Height") }}(m)
                      </div>
                      <div class="control">
                        <input
                          v-model="form.height"
                          class="input"
                          type="text"
                          :placeholder="localization('app-height-in-meter','Height in meter')"
                        />
                      </div>
                    </div>
                    <div class="field">
                      <b-checkbox
                        class="is-medium-16-500-19"
                        @input="on_select_bound"
                        v-model="select_bound"
                        type="is-info"
                        size="label"
                        
                        >{{
                          localization(
                            "app-select-from-extend",
                            "Select from extent"
                          )
                        }}</b-checkbox
                      >
                    </div>
                    <div
                      v-if="select_bound && !selected_bound"
                      class="is-lowercase has-text-info"
                    >
                      {{
                        localization(
                          "app-select-bounds-from-map",
                          "Select bounds from map"
                        )
                      }}
                    </div>
                    <div
                      class="field is-grouped"
                      v-if="(select_bound && selected_bound) || !select_bound"
                    >
                      <a
                        class="button is-info is-fullwidth"
                        :class="{
                          'is-loading': is_loading_volume,
                          'is-disabled':
                            form.method == 'surface-to-surface' &&
                            (!layer1 || !layer2),
                        }"
                        @click.stop="calculate_volume()"
                        
                        >{{
                          localization(
                            "app-calculate-volume",
                            "Calculate Volume"
                          )
                        }}</a
                      >
                    </div>
                    <div v-if="error" class="has-text-danger">{{ error }}</div>
                    <transition name="slide-fade">
                      <table
                        v-show="volume_results"
                        class="c-table is-uppercase is-size-7 table is-bordered is-fullwidth"
                      >
                        <thead v-if="volume_results">
                          <tr>
                            <td class="key" >
                              {{ localization("app-cut", "Cut") }}
                            </td>
                            <td>
                              {{ volume_results.cut.toFixed(3) }}
                              <span class="is-lowercase">
                                m
                                <sup>3</sup>
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td class="key" >
                              {{ localization("app-fill", "Fill") }}
                            </td>
                            <td>
                              {{ volume_results.fill.toFixed(3) }}
                              <span class="is-lowercase">
                                m
                                <sup>3</sup>
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td class="key" >
                              {{ localization("app-total", "Total") }}
                            </td>
                            <td>
                              {{ volume_results.total.toFixed(3) }}
                              <span class="is-lowercase">
                                m
                                <sup>3</sup>
                              </span>
                              <p class="is-lowercase">(sea level)</p>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </transition>
                  </div>
                </div>
              </div>

              <div aria-id="elevationCalculation" v-if="is_elevation_card">
                <div
                  slot="trigger"
                  slot-scope="props"
                  class="card-header"
                  role="button"
                  @click="is_elevation_card = !is_elevation_card"
                  aria-controls="contentIdForA11y3"
                >
                  <p
                    class="card-header-title is-uppercase is-size-7"
                    
                  >
                    {{
                      localization(
                        "app-elevation-calculation",
                        "Elevation Calculation"
                      )
                    }}
                  </p>
                  <a class="card-header-icon">
                    <b-icon
                      :icon="props.open ? 'menu-down' : 'menu-up'"
                    ></b-icon>
                  </a>
                </div>
                <div class="card-content" style="padding: 0 10px">
                  <div class="form">
                    <div class="field">
                      <div class="is-size-7 prop-title" >
                        {{ localization("app-method", "Method") }}
                      </div>
                      <div class="select">
                        <select v-model="elevation_form.method">
                          <option value="line" >
                            {{ localization("app-line", "Line") }}
                          </option>
                          <option value="point" >
                            {{ localization("app-point", "Point") }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <div class="is-size-7 prop-title" >
                        {{ localization("app-layer", "Layer") }}
                      </div>
                      <div class="select">
                        <select
                          v-model="elevation_form.layer"
                          class="is-uppercase"
                        >
                          <option
                            v-for="(report, i) of reports"
                            :key="i"
                            :value="report.key"
                          >
                            {{ report.key }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="field" v-if="elevation_form.method == 'line'">
                      <div class="is-size-7 prop-title" >
                        {{ localization("app-sampling-(m)", "Sampling(m)") }}
                      </div>
                      <div class="control">
                        <input
                          v-model="elevation_form.interval"
                          class="input"
                          type="number"
                          min="0.1"
                          max="10"
                          :placeholder="localization('app-sampling-in-meter','Sampling in meter')"
                        />
                      </div>
                    </div>
                    <div class="field">
                      <b-checkbox
                        class="is-medium-16-500-19"
                        @input="on_select_bound"
                        v-model="select_bound"
                        type="is-info"
                        size="label"
                        
                        >{{
                          localization("app-choose-extend", "Choose extend")
                        }}</b-checkbox
                      >
                    </div>
                    <div
                      v-if="select_bound && !selected_bound"
                      class="has-text-centered has-text-info"
                    >
                      {{
                        localization("app-select-from-map", "Select from map")
                      }}
                    </div>
                    <div
                      class="field is-grouped"
                      v-if="(select_bound && selected_bound) || !select_bound"
                    >
                      <a
                        class="button is-info is-fullwidth"
                        :class="{
                          'is-loading': is_loading_elevation,
                        }"
                        @click="calculate_elevation()"
                        
                        >{{
                          localization(
                            "app-calculate-elevation",
                            "Calculate Elevation"
                          )
                        }}</a
                      >
                    </div>
                    <transition name="slide-fade">
                      <table
                        v-show="
                          point_elevation && elevation_form.method !== 'line'
                        "
                        class="c-table is-uppercase is-size-7 table is-bordered is-fullwidth"
                      >
                        <thead v-if="point_elevation">
                          <tr>
                            <td class="key" >
                              {{ localization("app-elevation", "Elevation") }}
                            </td>
                            <td>
                              {{ point_elevation.elevations[2].toFixed(3) }}
                              <span class="is-lowercase" >{{
                                localization("app-meters", "meters")
                              }}</span>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </smooth-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GISService from "@/services/gis.service";
import FeatureService from "@/services/feature.service";
import { mapState } from "vuex";
import _ from "lodash";
import LineElevation from "./line-elevation.component";
import DsmDtmDropdown from "./dsm-dtm-dropdown";

export default {
  components: {
    LineElevation,
    DsmDtmDropdown,
  },
  data() {
    return {
      layer1: null,
      layer2: null,
      is_tools: false,
      error: "",
      gisService: new GISService(),
      featureService: new FeatureService(),
      volume_results: null,
      point_elevation: null,
      line_elevation: null,
      is_loading_volume: false,
      is_loading_elevation: false,
      is_volume_card: false,
      is_elevation_card: false,
      select_bound: false,
      selected_bound: null,
      selected_feature: null,
      form: {
        method: "base-height",
        layer: "dsm",
        height: 10,
      },
      elevation_form: {
        method: "line",
        layer: "dsm",
        interval: 10,
      },
    };
  },
  created() {
    document.addEventListener("click", (event) => {
      if (
        _.includes(["btn-save", "btn-edit", "btn-delete"], event.target.id) ||
        (event.target.parentNode &&
          _.includes(
            ["btn-save", "btn-edit", "btn-delete"],
            event.target.parentNode.id
          ))
      ) {
        this.is_tools = false;
      }

      if (
        event.target.id == "cal-volume" ||
        (event.target.parentNode && event.target.parentNode.id == "cal-volume")
      ) {
        this.is_tools = true;
        this.is_elevation_card = false;
        this.is_volume_card = true;
        this.selected_feature = this.draw.getSelected().features[0];
      } else if (
        event.target.id == "cal-elevation" ||
        (event.target.parentNode &&
          event.target.parentNode.id == "cal-elevation")
      ) {
        this.is_tools = true;
        this.is_volume_card = false;
        this.is_elevation_card = true;
        this.selected_feature = this.draw.getSelected().features[0];
      }
    });
  },
  computed: {
    ...mapState(["active_project", "draw", "map", "active_projects"]),
    reports() {
      let arr = [];
      if (this.active_project) {
        for (var key in this.active_project.reports) {
          if (
            (key == "dsm" || key == "dtm") &&
            this.active_project.reports.hasOwnProperty(key)
          ) {
            arr.push({ key: key, ...this.active_project.reports[key] });
          }
        }
      }
      return arr;
    },
  },
  watch: {
    is_tools: {
      handler(n, o) {
        if (n !== o) {
          parent.postMessage(
            {
              name: "change_icons_position",
              details_open: this.is_tools,
            },
            "*"
          );
        }
      },
    },
  },
  methods: {
    on_select_bound() {
      let projects = Object.values(this.active_projects);
      if (projects.length) {
        let bounds_to_add = { type: "FeatureCollection", features: [] };
        for (let p of projects) {
          if (p.meta && p.meta.bounds && p.is_ortho_active) {
            let f = turf.bboxPolygon(p.meta.bounds);
            f.properties["bounds"] = 1;
            f.properties["project_uid"] = p.info.uid;
            bounds_to_add.features.push(f);
          }
        }
        if (this.select_bound) {
          this.draw.add(bounds_to_add);
          this.map.on("draw.selectionchange", (e) => {
            if (e.features.length == 1 && e.features[0].properties.bounds) {
              this.selected_bound = e.features[0];
            } else {
              this.selected_bound = null;
            }
          });
        } else {
          this.delete_bounds();
        }
      }
    },
    delete_bounds() {
      let to_delete = [];
      for (let f of this.draw.getAll().features) {
        if (f.properties.bounds) {
          to_delete.push(f.id);
        }
      }
      this.draw.delete(to_delete);
      this.select_bound = false;
      this.selected_bound = null;
    },
    calculate_volume() {
      try {
        this.volume_results = null;
        this.error = "";
        let active_project = this.active_project;
        if (
          this.select_bound &&
          this.selected_bound &&
          this.selected_bound.properties.project_uid
        ) {
          active_project = this.active_projects[
            this.selected_bound.properties.project_uid
          ].info;
        }

        if (!this.selected_feature) {
          this.$toast.open("Select a feature!");
          return;
        }

        if (
          this.form.method == "base-height" ||
          this.form.method == "triangulated" ||
          this.form.method == "flat-minimum"
        ) {
          if (!active_project) {
            this.$toast.open("Select a project!");
            return;
          }
          if (!this.form.layer) {
            this.error = "Select a Layer";
            return;
          } else if (!active_project.reports[this.form.layer].url) {
            this.error = "Layer not found";
            return;
          }

          let body = {
            url: active_project.reports[this.form.layer].url,
            uid: active_project.reports[this.form.layer].uid,
            feature: this.selected_feature,
            options: {
              base_height: parseInt(this.form.height) || 10,
            },
          };
          this.is_loading_volume = true;
          if (this.form.method == "base-height")
            this.gisService
              .volume_base_height({ body })
              .then((res) => {
                this.is_loading_volume = false;
                this.volume_results = res.data.volumes;
                // this.volume_results = this.volume_results;
                // this.update_data_properties_volume(
                //   this.form,
                //   body,
                //   this.volume_results
                // );
              })
              .catch((err) => {
                this.handleErrors(err);
                this.is_loading_volume = false;
                console.log("Err:: volume base height", err);
              });
          else if (this.form.method == "triangulated") {
            delete body.options;
            this.gisService
              .volume_triangulated({ body })
              .then((res) => {
                this.is_loading_volume = false;
                this.volume_results = res.data.volumes;
                this.update_data_properties_volume(
                  this.form,
                  body,
                  res.data.volumes
                );
              })
              .catch((err) => {
                this.handleErrors(err);
                this.is_loading_volume = false;
                console.log("Err:: volume triangulated");
              });
          }
           else if (this.form.method == "flat-minimum") {
            delete body.options;
            this.gisService
              .volume_flat_minimum({ body })
              .then((res) => {
                this.is_loading_volume = false;
                this.volume_results = res.data.volumes;
                this.update_data_properties_volume(
                  this.form,
                  body,
                  res.data.volumes
                );
              })
              .catch((err) => {
                this.handleErrors(err);
                this.is_loading_volume = false;
                console.log("Err:: volume flat-minimum");
              });
          }
        } else if (this.form.method == "surface-to-surface") {
          if (
            !this.layer1 ||
            !this.layer1.url ||
            !this.layer2 ||
            !this.layer2.url
          ) {
            this.error = "Please select both layers!";
            return;
          }
          let body = {
            feature: this.selected_feature,
          };

          body.url = this.layer1.url;
          body.uid = this.layer1.uid;
          body.options = {
            target_raster: {
              url: this.layer2.url,
              uid: this.layer2.uid,
            },
          };
          this.is_loading_volume = true;
          this.gisService
            .volume_surface_to_surface({ body })
            .then((res) => {
              this.is_loading_volume = false;
              this.volume_results = res.data.volumes;
              this.update_data_properties_volume(
                this.form,
                body,
                res.data.volumes
              );
            })
            .catch((err) => {
              this.handleErrors(err);
              this.is_loading_volume = false;
              console.log("Err:: volume surface to surface");
            });
        }
      } catch (err) {
        console.log("Error:: while calculating volume", err);
      }
    },
    calculate_elevation() {
      try {
        let active_project = this.active_project;
        if (
          this.select_bound &&
          this.selected_bound &&
          this.selected_bound.properties.project_uid
        ) {
          active_project = this.active_projects[
            this.selected_bound.properties.project_uid
          ].info;
        }

        if (!active_project) {
          this.$toast.open("Select a project!");
          return;
        }
        if (!this.selected_feature) {
          this.$toast.open("Select a feature!");
          return;
        }

        if (
          this.elevation_form.method == "line" &&
          this.selected_feature.geometry.type !== "LineString"
        ) {
          this.$toast.open("Select Line.");
          return;
        }
        if (
          this.elevation_form.method == "point" &&
          this.selected_feature.geometry.type !== "Point"
        ) {
          this.$toast.open("Select Point.");
          return;
        }
        if (
          !active_project.reports[this.elevation_form.layer] ||
          !active_project.reports[this.elevation_form.layer].url
        ) {
          this.$toast.open("Layer not present.");
          return;
        }
        if (this.elevation_form.method === "point") {
          this.point_elevation = null;
          let body = {
            url: active_project.reports[this.elevation_form.layer].url,
            uid: active_project.reports[this.elevation_form.layer].uid,
            feature: this.selected_feature,
          };
          this.is_loading_elevation = true;
          this.gisService
            .elevation_point({ body })
            .then((res) => {
              this.is_loading_elevation = false;
              this.point_elevation = res.data;
            })
            .catch((err) => {
              this.handleErrors(err);
              this.is_loading_elevation = false;
            });
        } else if (this.elevation_form.method === "line") {
          if (this.elevation_form.interval < 0.1) {
            this.$toast.open("Sampling should be less than 0.1");
            return;
          }

          this.line_elevation = null;
          let body = {
            url: active_project.reports[this.elevation_form.layer].url,
            uid: active_project.reports[this.elevation_form.layer].uid,
            feature: this.selected_feature,
            options: {
              interval: parseFloat(this.elevation_form.interval),
            },
          };
          this.is_loading_elevation = true;
          this.gisService
            .elevation_line({ body })
            .then((res) => {
              this.is_loading_elevation = false;
              this.line_elevation = res.data.elevations;
            })
            .catch((err) => {
              this.handleErrors(err);
              this.is_loading_elevation = false;
            });
        }
      } catch (err) {
        console.log("Err :: while calculating elevation ");
      }
    },
    update_data_properties_volume(form, req_body, response) {
      let feature = this.selected_feature;

      if (!feature.properties.dataProperties)
        feature.properties.dataProperties = { volume: {} };

      if (!feature.properties.dataProperties.volume[form.method])
        feature.properties.dataProperties.volume[form.method] = {};

      if (!feature.properties.dataProperties["volume"][form.method][form.layer])
        feature.properties.dataProperties["volume"][form.method][form.layer] = {
          value: null,
          options: {},
        };

      feature.properties.dataProperties["volume"][form.method][
        form.layer
      ].value = response;

      feature.properties.dataProperties["volume"][form.method][
        form.layer
      ].options = req_body.options || {};
      // POST IT TO SERVER
      if (feature.properties.uid)
        this.featureService
          .put({
            uid: feature.properties.uid,
            body: feature,
          })
          .then((res) => {
            this.$toast.open("Updated feature dataProperties!");
            // UPDATE LOCAL FEATURE Props
            this.draw.setFeatureProperty(
              feature.id,
              "dataProperties",
              feature.properties.dataProperties
            );
          })
          .catch((err) => {
            this.handleErrors(err);
            console.log("Error :: Updated feature dataProperties!");
          });
    },
  },
};
</script>
<style lang="scss" scoped>
.tools {
  .card-header {
    .card-header-title {
      padding-top: 0;
      padding-left: 1rem;
    }
    .card-header-icon {
      padding-top: 0rem;
    }
  }
  .card-content .form .field {
    margin-bottom: 1.5rem;
    .prop-title {
      font-family: Barlow-medium;
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      color: #171e48;
    }
    select,
    input {
      padding-left: 0;
      font-family: Barlow-medium;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
      color: #171e48;
    }
    .button {
      border-radius: 6px;
      height: 40px;
      box-shadow: 0 2px 5px 0 rgba(92, 126, 247, 0.2);
      background-color: #5c7ef7;
    }
  }
  .card-content .tabs ul {
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1);
    background-color: #f4f7fc;
    margin-bottom: 0.8rem;
    li {
      padding: 0.5rem 0;
      border: none;
      a {
        opacity: 0.5;
        border: none;
        color: #171e48;
      }
    }
    li.is-active a {
      opacity: 1 !important;
    }
  }
}
</style>
